import axios from "axios";
import { getAuth } from "firebase/auth";
import fieldDecryption from "../Utilities/fieldDecryption";

const Axios = axios.create({
    baseURL: process.env.REACT_APP_AXIOS_API,
    headers: {
        "Content-Type": "application/json"
    }
});
Axios.interceptors.request.use(
    async (config) => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            const token = await user.getIdToken();
            config.headers.authorization = `PadelMates ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to automatically decrypt encrypted fields
Axios.interceptors.response.use(
  (response) => {
    if (response.data) {
      const encryptionEnabled = process.env.REACT_APP_ENCRYPTION_ENABLED_FROM_BACKEND || false;
      if (encryptionEnabled) {
        try {
            response.data = fieldDecryption.decryptApiResponse(response.data);
        } catch (error) {
            console.warn('Auto-decryption failed:', error.message);
            // Continue with original response if decryption fails
            return response;
        }
      }
    }
    return response;
  },
  (error) => Promise.reject(error),
);

export default Axios;
